<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni

  This file Buttons.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  Buttons.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: Buttons 
 Created by keni.
 with: IntelliJ IDEA
 Date: 10/09/2018
 Time: 13:44
------------------------------------------------------------------------------->
<template>
    <button
            v-on:click="$emit('buttonClick')"
            :class="{
                'btn--with-icon':typeof icon !== 'undefined' && icon !== null
            }"
            class="btn d-flex justify-content-center align-items-center">
        <i v-if="typeof icon !== 'undefined' && icon !== null"
                aria-hidden="true"
                class="material-icons"
        >{{icon}}</i>
        <slot name="content"></slot>
    </button>
</template>

<script>
	export default {
		name: "base-button",
		components: {},
		props: ['icon'],
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/buttons/Buttons.vue